import React from 'react';
import { ShieldCheck, PackageSearch, Truck, Users } from 'lucide-react';

export default function AboutPage() {
  return (
    <main className="bg-white" dir="rtl">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-50 to-white" />
        <div className="relative pp-container py-14">
          <div className="max-w-2xl">
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">درباره پارس پایپینگ</h1>
            <p className="mt-3 text-sm sm:text-base text-gray-600 leading-relaxed">
              ما در پارس پایپینگ با تمرکز روی تأمین پارس پایپینگ، اتصالات و تجهیزات پایپینگ،
              تلاش می‌کنیم تجربه‌ای سریع، دقیق و قابل اعتماد برای خریدهای صنعتی فراهم کنیم.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-blue-50 text-[#005bbb] text-xs font-bold">دیتا محور</span>
              <span className="px-3 py-1.5 rounded-full bg-blue-50 text-[#005bbb] text-xs font-bold">پاسخ‌گو</span>
              <span className="px-3 py-1.5 rounded-full bg-blue-50 text-[#005bbb] text-xs font-bold">کیفیت محور</span>
            </div>
          </div>
        </div>
      </section>

      {/* Value props */}
      <section className="pp-container py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Card icon={<ShieldCheck className="w-5 h-5" />} title="اصالت کالا" desc="سفارش شما با مشخصات دقیق و تأیید اصالت تحویل می‌شود." />
          <Card icon={<PackageSearch className="w-5 h-5" />} title="مشاوره فنی" desc="برای انتخاب درست سایز، کلاس فشاری و متریال کنار شما هستیم." />
          <Card icon={<Truck className="w-5 h-5" />} title="ارسال سریع" desc="فرآیند آماده‌سازی و ارسال، شفاف و قابل پیگیری است." />
          <Card icon={<Users className="w-5 h-5" />} title="همکاری با برندها" desc="برندهای معتبر صنعتی را یکجا و دسته‌بندی‌شده ارائه می‌کنیم." />
        </div>
      </section>

      {/* Story */}
      <section className="bg-gray-50 border-t border-gray-100">
        <div className="pp-container py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
            <div className="lg:col-span-7">
              <h2 className="text-lg sm:text-xl font-extrabold text-gray-900">چرا این وب‌سایت را ساختیم؟</h2>
              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                در خریدهای صنعتی، زمان و دقت مهم است. هدف ما این است که مسیر انتخاب و استعلام را ساده کنیم:
                دسته‌بندی‌های چندسطحی، فیلترها، مشخصات فنی و امکان ثبت پیش‌فاکتور، همه برای سرعت دادن به تصمیم‌گیری شماست.
              </p>
              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                این سایت به‌صورت کامل دیتامحور طراحی شده تا هر محصول، برند و دسته‌بندی از داشبورد مدیریت قابل کنترل باشد.
              </p>
            </div>
            <div className="lg:col-span-5">
              <div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
                <div className="text-sm font-bold text-gray-900">تعهد ما</div>
                <ul className="mt-4 space-y-3 text-sm text-gray-700">
                  <li className="flex gap-2"><span className="text-[#005bbb]">•</span> ارائه مشخصات فنی شفاف</li>
                  <li className="flex gap-2"><span className="text-[#005bbb]">•</span> پیگیری سریع پیش‌فاکتور</li>
                  <li className="flex gap-2"><span className="text-[#005bbb]">•</span> تجربه کاربری ساده و مینیمال</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

function Card({ icon, title, desc }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5">
      <div className="w-11 h-11 rounded-2xl bg-blue-50 text-[#005bbb] flex items-center justify-center">
        {icon}
      </div>
      <div className="mt-4 text-sm font-extrabold text-gray-900">{title}</div>
      <div className="mt-2 text-xs text-gray-600 leading-relaxed">{desc}</div>
    </div>
  );
}
